import { useGuest } from '@/context/guest';
import { ENABLE_ANNOUNCEMENT_MODE } from '../constants/feature-flags';

/**
 * Custom hook to return GuestName
 * @return {string}
 */
function useGroupLink() {
  const { guest, isLoading } = useGuest();

  if (!ENABLE_ANNOUNCEMENT_MODE) return true;
  if (isLoading) return false;
  return guest.is_group_link;
}

export default useGroupLink;